(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-jrj-clear-cart]');
    if (!button || button.disabled) return;

    var message = button.getAttribute('data-confirm-message') || 'Remove every item from this cart?';
    if (!window.confirm(message)) return;

    var originalText = button.textContent;
    var statusId = button.getAttribute('aria-describedby');
    var status = statusId ? document.getElementById(statusId) : null;
    var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'EMPTYING CART…';
    if (status) status.textContent = '';

    fetch(shopRoot + 'cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart clear request failed');
        return response.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = originalText;
        if (status) status.textContent = 'The cart could not be emptied. Please try again.';
      });
  });
})();
